<template>
  <section class="tabs -type-2 !tw-block">
    <div class="tabs__test">
      <div class="container">
        <div class="row y-gap-15 justify-between items-end">
          <div class="col-lg-6">
            <div class="text-62 md:text-38 fw-500" v-html="vars.titleHtml"></div>
          </div>

          <div class="col-auto">
            <div class="tabs__nav d-flex">
              <button
                class="button -outline-white size-80 text-20 text-white -prev js-tabsSlider-prev !tw-rounded-full"
                style="border: 1px solid #fff"
                tabindex="-1"
                aria-label="Previous slide"
              >
                <i class="icon-left-arrow"></i>
              </button>
              <button
                class="button -outline-white size-80 text-20 text-white -next ml-20 js-tabsSlider-next !tw-rounded-full"
                style="border: 1px solid #fff"
                tabindex="0"
                aria-label="Next slide"
              >
                <i class="icon-right-arrow"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="slider js-tabsSlider">
      <div class="swiper-wrapper">
        <div
          v-for="(label, idx) in labels"
          :key="idx"
          class="swiper-slide"
          role="group"
          :aria-label="`${idx + 1} / ${labels.length}`"
        >
          <div class="container">
            <div class="row">
              <div class="col-auto">
                <div class="tabs__content">
                  <div class="tabs__bg">
                    <img :src="label.photo || ''" alt="image" />
                  </div>

                  <h4 style="color: var(--c-text_primary)">{{ label.title }}</h4>
                  <p class="description-text pt-60 md:pt-30 tw-max-w-[800px]" style="color: white !important">
                    {{ label.description }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme8StorySlider',
  mixins: [ComponentMixin],
  data() {
    return {
      activeIndex: 0,
    };
  },
  computed: {
    labels() {
      return this.groupedVariables.labels;
    },
    descriptions() {
      return this.groupedVariables.descriptions;
    },
  },
  methods: {
    goTo(index: number) {
      this.activeIndex = index;
    },
    onViewMore(item: any) {
      this.$emit('view-more', item);
    },
  },
});
</script>

<style scoped>
.description-text {
  color: white !important;
  text-fill-color: white !important;
  -webkit-text-fill-color: white !important;
}
</style>
